export interface IApiCity {
  id: string;
  name: string;
  countryId: string;
  isPublished: boolean;
  images: Array<{ type: number; imageUrl: string; }>;
}
